import React, { FC } from 'react'
import styled from 'styled-components'

import useSiteSettings from '../../../../../../hooks/useSiteSettings'
import { langCodes } from '../../../../../../utils/siteSettings'
import { StyledContainer, StyledInformationIcon, StyledSmallParagraph } from '../styled'

import informationIcon from '../../../../../../img/information-circle.svg'

const StyledEmail = styled.a`
  color: ${({ theme }) => theme.colors.brand.orange};
  white-space: nowrap;
`

export const DeactivateDispensaryMessage: FC = () => {
  const { lang } = useSiteSettings()
  return (
    <StyledContainer>
      <StyledInformationIcon src={informationIcon} />
      <StyledSmallParagraph>
        Practitioners that {lang === langCodes.en_CA ? 'do not wish' : 'are not legally allowed'} to
        earn commissions or view sales data of potential patients may request to disable access to
        Virtual Dispensary data and commissions by contacting us at{' '}
        <StyledEmail href="mailto:support@designsforhealth.com" target="_blank" rel="noreferrer">
          support@designsforhealth.com
        </StyledEmail>
      </StyledSmallParagraph>
    </StyledContainer>
  )
}
